import React, { useState, useMemo } from "react";
import { Box, Button, Grid, Tab, Tabs, TextField } from "@mui/material";
import { ModalAddUser } from "./panelUsers/ModalAddUser";
import { useGetUsers } from "../../hooks/panelUsers/useGetUsers";
import { UsersTable } from "./panelUsers/UsersTable";
import { AdminTable } from "./panelUsers/AdminTable";

const ROLES = {
  ADMIN: "admin",
  EDITOR: "editor",
  CLIENT: "usuario",
};

export const UsersPanel = ({ token }) => {
  const [openModal, setOpenModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const { users, loading } = useGetUsers(token, refresh);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const { clients, admins } = useMemo(() => {
    if (!users) return { clients: [], admins: [] };

    const filteredUsers = users.filter((user) =>
      user.user_name.toLowerCase().includes(searchTerm)
    );

    return {
      clients: filteredUsers.filter((user) => user.rol === ROLES.CLIENT),
      admins: filteredUsers.filter((user) =>
        [ROLES.ADMIN, ROLES.EDITOR].includes(user.rol)
      ),
    };
  }, [users, searchTerm]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <>
      <Grid
        container
        spacing={2} 
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Grid item xs={6} sm={6} md={6}>
          <TextField
            label="Buscar usuario"
            variant="outlined"
            value={searchTerm}
            onChange={handleSearch}
            fullWidth
          />
        </Grid>
        <Grid item xs={6} sm={6} md={2}>
          <Button
            variant="contained"
            fullWidth
            color="primary"
            sx={{
              borderRadius: "12px",
              height: "100%",
            }}
            onClick={() => setOpenModal(true)}
          >
            Agregar usuario
          </Button>
        </Grid>
      </Grid>
  
      <Box>
        <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 2.5 }}>
          <Tab label={`Usuarios / Clientes (${clients.length})`} />
          <Tab label={`Administradores / Editores (${admins.length})`} />
        </Tabs>

        {tabIndex === 0 && (
          <UsersTable
            token={token}
            refresh={() => setRefresh(!refresh)}
            users={clients}
            loading={loading}
          />
        )}

        {tabIndex === 1 && (
          <AdminTable
            token={token}
            refresh={() => setRefresh(!refresh)}
            users={admins}
            loading={loading}
          />
        )}
      </Box>

      <ModalAddUser
        open={openModal}
        onClose={() => setOpenModal(false)}
        token={token}
        refresh={() => setRefresh(!refresh)}
      />
    </>
  );
};
